import { instantsInterceptor, } from '@/api/index';
import axios from "axios";
import { setInterceptors } from "@/api/common/interceptor";

function goCheckId(user) {
    return instantsInterceptor.post('/api/check', user);
}

function saveUser(user) {
    return instantsInterceptor.post('/api/save', user);
}

function sendSMS(user) {
    return instantsInterceptor.post('/api/sms/send', user);
}

function checkCerti(user) {
    return instantsInterceptor.post('/api/sms/verify', user);
}

function forgotId(user) {
    return instantsInterceptor.post('/api/forgotid', user);
}

function getMgmtUser(form) {
    return instantsInterceptor.post('/mgmt/user/admin/list', form);
}

function getAllUserList(form) {
    return instantsInterceptor.post('/mgmt/user/list', form);
}

function getUserDetail(loginId) {
    return instantsInterceptor.post('/mgmt/user/detail', { loginId: loginId });
}

function saveUserDocAuth(authList) {
    return instantsInterceptor.post('/mgmt/user/auth/save', authList);
}

function initPassword(user) {
    return instantsInterceptor.post('/mgmt/user/init/password', user);
}

function saveUserRole(roleList) {
    return instantsInterceptor.post('/mgmt/user/role/save', roleList);
}

function getUserRole(form) {
    return instantsInterceptor.post('/mgmt/user/role/list', form);
}

function sendValidateMail(user) {
    return instantsInterceptor.post('/api/mail/sendvalidate', user);
}

function getValidateMailStatus(id) {
    return instantsInterceptor.post('/api/mail/status', id);
}

function setValidateYn(param) {
    return instantsInterceptor.post('/api/mail/validate/', param);
}

function changeActiveFlag(user) {
    return instantsInterceptor.post('/mgmt/user/edit', user);
}

function saveUserDocDownloadAuth(authList){
    return instantsInterceptor.post('/mgmt/user/downloadauth/save', authList);
}

function downExcel(form) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.post('/mgmt/user/excel', form);
}

function updateUserDocumentauth(user) {
    return instantsInterceptor.post('/mgmt/user/userDocumentauth', user);
}

function saveMgmtUser(user) {
    return instantsInterceptor.post('/mgmt/user/save', user);
}

function deleteUser(user) {
    return instantsInterceptor.post('/mgmt/user/delete', user);
}

export {
    goCheckId,
    saveUser,
    sendSMS,
    checkCerti,
    forgotId,
    getMgmtUser,
    getAllUserList,
    getUserDetail,
    saveUserDocAuth,
    initPassword,
    saveUserRole,
    getUserRole,
    sendValidateMail,
    getValidateMailStatus,
    setValidateYn,
    changeActiveFlag,
    downExcel,
    updateUserDocumentauth,
    saveMgmtUser,
    deleteUser,
    saveUserDocDownloadAuth
};